import { render, staticRenderFns } from "./myNews.vue?vue&type=template&id=feaadcf8&scoped=true"
import script from "./myNews.vue?vue&type=script&lang=ts"
export * from "./myNews.vue?vue&type=script&lang=ts"
import style0 from "./myNews.vue?vue&type=style&index=0&id=feaadcf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaadcf8",
  null
  
)

export default component.exports